module.exports = "/static/img/why_we_do_it_bg.png?ae18146aa3d99eb5036df7546622e1c7";